module.exports = __webpack_public_path__ + "static/media/logo IF.0f71de69.png";